// extracted by mini-css-extract-plugin
export default {"tooltip":"TextToolTip_tooltip__d3zEB","tooltiptext":"TextToolTip_tooltiptext__T1mKM"};